import TransitionLink from './component'

export default TransitionLink
